import React from 'react';
import { Typography } from '@mui/material';
import Order from '@components/order/models/list/Order';
import _ from 'lodash';
import { Variant } from '@mui/material/styles/createTypography';

interface OrderListItemAddressProps {
    order: Order;
    variant?: Variant
}

const OrderListItemAddress: React.FC<OrderListItemAddressProps> = ({ order, variant = "subtitle2" }) => {
    const getText = (order: Order) => {
        if (order.isComingForOrder) {
            return "Dolazim po narudžbu"
        }
        else if (order.isServedInRestaurant) {
            return "Jedem u restoranu"
        }
        return order.address;
    }
    return (
        <Typography variant={variant} color={"text.secondary"} textAlign={"left"}>{getText(order)}</Typography>
    )
}

export default OrderListItemAddress;